import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/primeng';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { SiteService } from 'src/app/Services/SiteService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IAttendanceSchedule } from 'src/app/Models/IAttendanceSchedule';
import { ISitePauDetail } from 'src/app/Models/ISitePauDetail';
import { IProviderCertificationRequest } from 'src/app/Models/IProviderCertificationRequest';

@Component({
  selector: 'app-_121_CertifyServiceRegisterReport',
  templateUrl: './_121_CertifyServiceRegisterReport.component.html',
  styleUrls: ['./_121_CertifyServiceRegisterReport.component.css']
})
export class _121_CertifyServiceRegisterReportComponent implements OnInit {
  _globals: Globals

  date: Date = new Date;
  isInactiveSite: boolean = false;
  userRoleName: string;
  attendancePeriodList: ILookupBase[] = [];
  wrapperSitesList: [ILookupBase[]] = [[]];
  providerUncertifiedSitesList: ILookupBase[] = [];
  administratorUncertifiedSitesList: ILookupBase[] = [];
  certifiedSitesList: ILookupBase[] = [];
  sitePauDetailList: ISitePauDetail[] = [];

  targetAttendanceSchedule: IAttendanceSchedule;
  mostRecentAttendancePeriod: string;
  selectedAttendancePeriodValue: string;
  selectedAttendancePeriod: SelectItem;
  selectedProviderUncertifiedSite: SelectItem;
  selectedAdministratorUncertifiedSite: SelectItem;
  selectedCertifiedSite: SelectItem;

  providerCertifyButtonDisabled: boolean = true;
  administratorCertifyButtonDisabled: boolean = true;
  messages: Message[];

  _lookupService: LookupService;
  _reportService: ReportService;
  _siteService: SiteService;
  public showSpinner: boolean = false;
  spinnerMessage: string = 'Please wait while the report is generated.'
  _baseUrl: string;

  constructor(lookupService: LookupService, reportService: ReportService, siteService: SiteService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._globals = globals;
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._siteService = siteService;
    this._baseUrl = baseUrl;
  }

  ngOnInit() {
    this._lookupService.getLookupAttendancePeriod(this._baseUrl + 'api/Lookup/Get121ReportAttendanceScheduleList/')
      .subscribe((res: ILookupBase[]) => {
        this.attendancePeriodList = res;
        this.userRoleName = this._globals.spedSecurityUser.roleName;
        this.mostRecentAttendancePeriod = this.attendancePeriodList[0].value;
        this.selectedAttendancePeriodValue = this.attendancePeriodList[0].value;
        this.selectedAttendancePeriod = this.attendancePeriodList[0];
        this.setAttendancePeriod(this.selectedAttendancePeriod.value);
      },
        err => console.error(err)
    );

    this._siteService.get121TargetAttendanceSchedule()
      .subscribe((res: IAttendanceSchedule) => {
        this.targetAttendanceSchedule = res
      },
        err => console.error(err)
    );

    this._siteService.get121SitePauDetailsList()
      .subscribe((res: ISitePauDetail[]) => {
        this.sitePauDetailList = res
      },
        err => console.error(err)
      );
  }

  setAttendancePeriod(id): void {
    this.disableCertifyButtons();
    this.selectedAttendancePeriodValue = id.value == undefined ? id : id.value;
    this._siteService.get121Sites(id.value == undefined ? id : id.value)
      .subscribe((res: [ILookupBase[]]) => {
        res
        let i: number = 0;
        for (let sitesList of res) {
          switch (i) {
            case 0:
              this.providerUncertifiedSitesList = sitesList;
              break;
            case 1:
              this.administratorUncertifiedSitesList = sitesList;
              break;
            case 2:
              this.certifiedSitesList = sitesList;
              break;
          }
          i++;
        }
      },
        err => console.error(err)
      );
  }

  providerUncertifiedSitesChanged(id): void {
    this.disableCertifyButtons();
    if (this._globals.spedSecurityUser.roleName == 'Provider') {
      var reportRequest = this.buildReportRequest(true);

      this.spinnerMessage = 'Please wait while the preview report is generated.'
      this.showSpinner = true;
      this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        this.showSpinner = false;
        saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
        this.providerCertifyButtonDisabled = false;  // This enables the provider certify button
      },
        err => {
          this.showSpinner = false;
          console.error(err);
        }
      );
    } else {
      alert('Only Service Providers can process Provider Uncertified Sites.');
    }
  }


  private buildReportRequest(isForProvider: boolean): IReportRequest {
    let sitePauDetail: ISitePauDetail;
    let academicYear: string;
    let administratorName: string;
    let attendancePeriod: string;
    let pauName: string;
    let siteName: string;
    let serviceProviderName: string;
    let siteId: string;
    let providerLocalStaffId: string;
    let startDate: string;
    let academicYearPeriod: string = this.selectedAttendancePeriod.value == undefined ? this.selectedAttendancePeriod : this.selectedAttendancePeriod.value;
    let providerUncertifiedSite: string = this.selectedProviderUncertifiedSite.value == undefined ? this.selectedProviderUncertifiedSite : this.selectedProviderUncertifiedSite.value;
    var selectedAttendancePeriodLabel = this.attendancePeriodList.find(z => z.value === academicYearPeriod).label
    var selectedProviderUncertifiedLabel = this.providerUncertifiedSitesList.find(z => z.value === providerUncertifiedSite).label

    this.disableCertifyButtons();

    if (this.selectedProviderUncertifiedSite.value != null &&
      academicYearPeriod != null &&
      selectedAttendancePeriodLabel != null &&
      selectedProviderUncertifiedLabel != null) {

      academicYear = academicYearPeriod.slice(0, academicYearPeriod.indexOf('^'));
      administratorName = '.';
      attendancePeriod = selectedAttendancePeriodLabel;
      pauName = 'PAU';
      siteName = selectedProviderUncertifiedLabel.slice(0, selectedProviderUncertifiedLabel.indexOf('/') - 2);
      serviceProviderName = selectedProviderUncertifiedLabel.slice(selectedProviderUncertifiedLabel.indexOf('/') + 2);
      siteId = this.selectedProviderUncertifiedSite.value.slice(0, this.selectedProviderUncertifiedSite.value.indexOf('^'));
      providerLocalStaffId = this.selectedProviderUncertifiedSite.value.slice(this.selectedProviderUncertifiedSite.value.indexOf('^') + 1);
      startDate = selectedAttendancePeriodLabel.slice(selectedAttendancePeriodLabel.indexOf('-') + 2, selectedAttendancePeriodLabel.indexOf(' to '));

      sitePauDetail = this.sitePauDetailList.find(z => z.siteId === siteId);
      if (sitePauDetail != null) {
        pauName = sitePauDetail.pauName;
        administratorName = this._globals.spedSecurityUsername; //sitePauDetail.administratorName;
      }

      if (isForProvider) {
        administratorName = '.';
      }
    }

    let reportParamArray: IReportParameter[] = [];

    reportParamArray.push(
      { parameterName: 'AcademicYear', parameterValue: academicYear },
      { parameterName: 'AdministratorName', parameterValue: administratorName },
      { parameterName: 'AttendancePeriod', parameterValue: attendancePeriod },
      { parameterName: 'CertificationDate', parameterValue: this.date.toLocaleDateString().slice(0, 10) },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'PAU_Name', parameterValue: pauName },
      { parameterName: 'ProviderName', parameterValue: serviceProviderName },
      { parameterName: 'ServiceProviderName', parameterValue: serviceProviderName },
      { parameterName: 'ServiceProviderStaffIdList', parameterValue: providerLocalStaffId },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'SiteIdList', parameterValue: siteId },
      { parameterName: 'SiteName', parameterValue: siteName },
      { parameterName: 'StartDate', parameterValue: startDate }
    );

    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_SpecialEd_ServiceRegister_Certify";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    return reportRequest;
  }

  administratorUncertifiedSitesChanged(id): void {
    this.disableCertifyButtons();
    this.spinnerMessage = 'Please wait while the report is retrieved.'
    this.showSpinner = true;
    this._siteService.getAdministratorUncertifiedServiceRegister(this.selectedAdministratorUncertifiedSite.value).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
      if (this._globals.spedSecurityUser.roleName == 'SiteAdministrator') {
        this.administratorCertifyButtonDisabled = false;  // This enables the Administrator certify button
      }
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

  certifiedSitesChanged(id): void {
    this.disableCertifyButtons();
    if (this.selectedCertifiedSite.label.includes('Inactive')) {
      alert('Note: Inactive service registers cannot be printed.');
    }
    else {
      this.spinnerMessage = 'Please wait while the report is retrieved.'
      this.showSpinner = true;
      this._siteService.getAdministratorCertifiedServiceRegister(this.selectedCertifiedSite.value).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        this.showSpinner = false;
        saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
      },
        err => {
          this.showSpinner = false;
          console.error(err);
        }
      );
    }
  }

  disableCertifyButtons() {
    this.providerCertifyButtonDisabled = true;
    this.administratorCertifyButtonDisabled = true;
  }

  providerCertifyReport(): void {
    this.spinnerMessage = 'Please wait while the report is certified and saved to the database.'
    this.showSpinner = true;
    this.clearMessages();
    let academicYearPeriod: string = this.selectedAttendancePeriod.value == undefined ? this.selectedAttendancePeriod : this.selectedAttendancePeriod.value;

    let providerCertificationRequest = {} as IProviderCertificationRequest;
    providerCertificationRequest.administratorIReportRequest = this.buildReportRequest(false);
    providerCertificationRequest.isCertificationNotRequired = this.isInactiveSite;
    providerCertificationRequest.period = Number(academicYearPeriod.slice(academicYearPeriod.indexOf('^') + 1));
    providerCertificationRequest.providerIReportRequest = this.buildReportRequest(true);
    providerCertificationRequest.schoolYear = academicYearPeriod.slice(0, academicYearPeriod.indexOf('^'));
    providerCertificationRequest.siteId = this.selectedProviderUncertifiedSite.value.slice(0, this.selectedProviderUncertifiedSite.value.indexOf('^'));

    this._siteService.insertProviderCertification(providerCertificationRequest).subscribe((res) => {
      if (res > 0) {
        let successMessage: Message = { severity: 'success', summary: 'Certification record Saved Successfully.  Id : ', detail: res.toString() };
        this.addMessage(successMessage);
      } else {
        let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: '' };
        this.addMessage(errorMessage);
      }

      this.showSpinner = false;
      this.disableCertifyButtons();
      this.setAttendancePeriod(this.selectedAttendancePeriod.value);  // this should refresh the lists and the record should disappear from the provider list and now appear on the Administrator Uncertified list 
    },
      err => {
        this.showSpinner = false;
        this.disableCertifyButtons();
        console.error(err);
      }
    );
  }

  administratorCertifyReport(id): void {
    this.disableCertifyButtons();
    this.spinnerMessage = 'Please wait while the report is certifed and saved to the database.'
    this.showSpinner = true;
    this.clearMessages();
    this._siteService.certifyAdministrator(this.selectedAdministratorUncertifiedSite.value).subscribe((res) => {
      if (res) {
        let successMessage: Message = { severity: 'success', summary: 'Administrator Certification Succeeded.', detail: ''};
        this.addMessage(successMessage);
      } else {
        let errorMessage: Message = { severity: 'error', summary: 'Administrator Certification Failed', detail: '' };
        this.addMessage(errorMessage);
      }
      this.showSpinner = false;
      this.disableCertifyButtons();
      this.setAttendancePeriod(this.selectedAttendancePeriod.value);  // this should refresh the lists and the record should disappear from the Administrator Uncertified list and now appear on the Administrator Certified list 
    },
      err => {
        this.showSpinner = false;
        this.disableCertifyButtons();
        let errorMessage: Message = { severity: 'error', summary: 'Administrator Certification Failed', detail: '' };
        this.addMessage(errorMessage);
        console.error(err);
      }
    );
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  printSitesPDF(): void {
    let userRole: number = 0;
    this.spinnerMessage = 'Please wait while the report is generated.'
    this.showSpinner = true;
    let reportParamArray: IReportParameter[] = [];


    switch (this._globals.spedSecurityUser.roleName)
    {
      case "SELPA":
      case "SysAdmin":
        userRole = 3;
        break;
      case "SiteAdministrator":
        userRole = 2;
        break;
      case "Provider":
        userRole = 1;
        break;
    }

    var key = "";

    if (this.selectedAttendancePeriod.label === undefined) {
      key = this.selectedAttendancePeriod.toString();
    } else {
      key = this.selectedAttendancePeriod.value;
    }

    var selectedAttendacePeriodValue = this.attendancePeriodList.find(k => k.value === key).label;

    reportParamArray.push(
      { parameterName: 'AttendancePeriod', parameterValue: selectedAttendacePeriodValue.slice(selectedAttendacePeriodValue.indexOf('-') + 2) },
      { parameterName: 'LocalStaffID', parameterValue: this._globals.spedSecurityUser.localStaffId },
      { parameterName: 'PeriodNumber', parameterValue: key.slice(10) },
      { parameterName: 'ServiceProviderName', parameterValue: this._globals.spedSecurityUser.firstName + ' ' + this._globals.spedSecurityUser.lastName },
      { parameterName: 'SchoolYear', parameterValue: key.slice(0,9) },
      { parameterName: 'UserRole', parameterValue: userRole.toString() }
    );

    let now = new Date();
    let localReportFileName = '121-CertifyServiceRegister_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_SpecialEd_ServiceRegister_Certify_SitesStatus"; 
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }
  printSitesExcel(): void { }
}
